<template>
  <div class="bg_news">
    <v-container>
      <v-row justify="center">
        <h1 class="primary--text mt-1">ข่าวสารและกิจกรรม</h1>
        <v-btn
          class="float-right ml-5 mt-0"
          align="center"
          justify="center"
          color="#636262"
          text
          fab
          @click="openSetting()"
          v-if="mode"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-row>
      <!-- <pre>{{event_data}}</pre> -->
      <v-container fluid v-if="event_data.length == 0">
        <!-- <v-card> -->
        <v-card-title>- ไม่มีข้อมูล -</v-card-title>
        <!-- </v-card> -->
      </v-container>
      <v-container fluid v-else>
        <v-row dense>
          <v-col cols="12" md="4" sm="12" xs="12">
            <!--  selectedEvent.category_id == 5
                        ? $router.push({
                            name: 'CalendarWeekDetail',

                            query: {
                              id: selectedEvent.event_id,
                            },
                          })
                        : selectedEvent.category_id == 1
                        ? $router.push(
                            '/newsandevent_detail/detail?id=' +
                              selectedEvent.event_id +
                              '&position_cate=' +
                              selectedEvent.event_position_id
                          )
                        : -->
            <!-- <pre>{{ event_data[0] }}</pre> -->
            <v-card
              @click="
                event_data[0].category_id == 5
                  ? $router.push({
                      name: 'CalendarWeekDetail',

                      query: {
                        id: event_data[0].event_id,
                      },
                    })
                  : event_data[0].category_id == 1
                  ? $router.push(
                      '/newsandevent_detail/detail?id=' +
                        event_data[0].event_id +
                        '&position_cate=' +
                        event_data[0].event_position_id
                    )
                  : $router.push(
                      '/newsandevent_detail/detail?id=' +
                        event_data[0].event_id +
                        '&position_cate=0'
                    )
              "
            >
              <v-img
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                v-if="event_data[0].file != ''"
                :src="
                  event_data[0].file[0].event_file_path
                    ? env + '/' + event_data[0].file[0].event_file_path
                    : ''
                "
                height="412px"
              >
                <v-card-title
                  style="
                    background: linear-gradient(
                      90deg,
                      #1d6d7d 54.89%,
                      rgba(29, 109, 125, 0) 100%
                    );
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title style="line-height: 24px">
                      {{ event_data[0].event_name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-card-title>
              </v-img>
              <v-img
                v-else
                :src="require('@/assets/no-img.svg')"
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                height="412px"
              >
                <v-card-title>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ event_data[0].event_name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-card-title>
              </v-img>
            </v-card>
          </v-col>

          <v-col cols="12" md="4" sm="12" xs="12">
            <v-row class="py-0">
              <v-col cols="12" md="12" sm="12" xs="12" class="py-0">
                <v-card
                  @click="
                    event_data[1].category_id == 5
                      ? $router.push({
                          name: 'CalendarWeekDetail',

                          query: {
                            id: event_data[1].event_id,
                          },
                        })
                      : event_data[1].category_id == 1
                      ? $router.push(
                          '/newsandevent_detail/detail?id=' +
                            event_data[1].event_id +
                            '&position_cate=' +
                            event_data[1].event_position_id
                        )
                      : $router.push(
                          '/newsandevent_detail/detail?id=' +
                            event_data[1].event_id +
                            '&position_cate=0'
                        )
                  "
                >
                  <v-img
                    v-if="event_data[1].file != ''"
                    :src="
                      event_data[1].file[0].event_file_path
                        ? env + '/' + event_data[1].file[0].event_file_path
                        : ''
                    "
                    class="white--text align-end"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    height="200px"
                  ></v-img>
                  <v-img
                    v-else
                    :src="require('@/assets/no-img.svg')"
                    class="white--text align-end"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    height="200px"
                  ></v-img>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" sm="12" xs="12">
                <v-card
                  @click="
                    event_data[2].category_id == 5
                      ? $router.push({
                          name: 'CalendarWeekDetail',

                          query: {
                            id: event_data[2].event_id,
                          },
                        })
                      : event_data[2].category_id == 1
                      ? $router.push(
                          '/newsandevent_detail/detail?id=' +
                            event_data[2].event_id +
                            '&position_cate=' +
                            event_data[2].event_position_id
                        )
                      : $router.push(
                          '/newsandevent_detail/detail?id=' +
                            event_data[2].event_id +
                            '&position_cate=0'
                        )
                  "
                >
                  <v-img
                    v-if="event_data[2].file != ''"
                    :src="
                      event_data[2].file[0].event_file_path
                        ? env + '/' + event_data[2].file[0].event_file_path
                        : ''
                    "
                    class="white--text align-end"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    height="200px"
                  ></v-img>
                  <v-img
                    v-else
                    :src="require('@/assets/no-img.svg')"
                    class="white--text align-end"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    height="200px"
                  ></v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="4" sm="12" xs="12" class="py-0">
            <v-row align="center" justify="center" class="py-0">
              <v-col cols="12" md="12" sm="12" xs="12" class="py-1">
                <div style="height: 200px" height="200px">
                  <v-card-title class="pl-4 py-0">
                    <v-list-item-content>
                      <v-list-item-title class="headnews">
                        {{ event_data[1].event_name }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-card-title>
                  <v-card-text
                    class="max-lines"
                    style="font-size: 16px; word-wrap: break-word"
                    v-html="lenght_data(event_data[1].event_detail)"
                  ></v-card-text>
                </div>
              </v-col>

              <v-col cols="12" md="12" sm="12" xs="12" class="pt-2">
                <div style="height: 200px" height="200px">
                  <v-card-title class="pl-4 py-0">
                    <v-list-item-content>
                      <v-list-item-title class="headnews">
                        {{ event_data[2].event_name }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-card-title>
                  <v-card-text
                    class="max-lines"
                    style="font-size: 16px"
                    v-html="lenght_data(event_data[2].event_detail)"
                  ></v-card-text>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="pa-0">
          <v-col class="pa-0">
            <v-btn
              @click="$router.push('/allnews')"
              color="primary"
              dark
              text
              class="px-2 float-right font-weight-bold"
              style="font-size: 16px; font-weight: bold"
            >
              ดูทั้งหมด
              <!-- <v-icon class="ml-1">mdi-plus</v-icon> -->
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <DialogCalendarSetting
      @getNews="getEvent"
      ref="dialog_news_setting"
    ></DialogCalendarSetting>
  </div>
</template>
<script>
// import DialogNews from "../Settings/DialogNews";
import DialogCalendarSetting from "../Settings/DialogCalendarSetting.vue";

export default {
  components: {
    DialogCalendarSetting,
  },
  data: () => ({
    env: process.env.VUE_APP_API,
    mode: false,
    event_data: [],
  }),
  created() {
    this.mode = this.$session.get("token")
      ? this.$session.get("permission") == "admin"
      : false;
    this.getEvent();
  },
  watch: {
    "$store.state.event_status"(val) {
      // console.log(val);
      // if (val == true) {
      this.getEvent();
      // }
    },
    "$store.state.news_status"(val) {
      // console.log(val);

      // if (val == true) {
      this.getEvent();
      // }
    },
  },
  methods: {
    getEvent() {
      let data_not_token = [];
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/event_cat")
        .then((response) => {
          let get_event = [];
          // console.log(response.data);
          get_event = response.data;
          if (this.$session.get("token")) {
            this.event_data = get_event;
          } else {
            get_event.forEach((element) => {
              if (
                element.event_position_id != 1 &&
                element.event_position_id != 2 &&
                element.event_position_id != 3
              ) {
                // if (element.event_position_id == 7) {
                //   if (element.category_id != 5) {
                data_not_token.push(element);
              }
              //   } else {
              //     data_not_token.push(element);
              //   }
              // }
            });
            // console.log(data_not_token);
            this.event_data = data_not_token;
          }

          this.$store.state.event_status = false;
        });
    },
    lenght_data(data) {
      const max_lenght = 200;
      let data_string = "";
      for (let index = 0; index < max_lenght; index++) {
        data_string += data[index];
      }
      data_string += "...";
      if (data.length < max_lenght) {
        return data;
      } else {
        return data_string;
      }
    },

    openSetting() {
      this.$refs.dialog_news_setting.openSetting();
    },
  },
};
</script>
<style>
.max-lines {
  display: block; /* or inline-block */
  text-overflow: ellipsis;
  /* word-wrap: break-word; */
  /*overflow: hidden;*/
  /*max-height: 3.6em;*/
  /* line-height: 1.8em; */
  /*word-break: break-all;*/
  height: 141px;
  word-break: break-word;
  overflow: hidden;
}

.max-lines p {
  margin: 0 !important;
}
</style>
